import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "upload button default primary add-btn-primary"
}
const _hoisted_4 = ["accept"]
const _hoisted_5 = {
  key: 1,
  class: "rows"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "preview"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "pdf-icon"
}
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "date" }
const _hoisted_13 = { class: "wrapper-dots" }
const _hoisted_14 = { class: "menu-option" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "row"
}
const _hoisted_19 = {
  key: 0,
  class: "name"
}
const _hoisted_20 = {
  key: 1,
  class: "name"
}
const _hoisted_21 = {
  key: 2,
  class: "spinner"
}
const _hoisted_22 = { class: "description--highlighted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card card-documents", { inner: $props.inner }])
  }, [
    ($setup.lotId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString($props.tab), 1),
          ($setup.canManageLot)
            ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
                _createTextVNode("Add " + _toDisplayString($props.tab === $setup.DocumentTypeEnum.DOCUMENTS ? "Document" : "Contract"), 1),
                _createElementVNode("input", {
                  type: "file",
                  ref: "fileInput",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.uploadDocument($event))),
                  accept: $setup.documentTypes
                }, null, 40, _hoisted_4)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (($props.tab === $setup.DocumentTypeEnum.DOCUMENTS || $props.tab === $setup.DocumentTypeEnum.CONTRACTS) && !$setup.isContactsPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.docs, (doc, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: "clicked-wr",
                      onClick: ($event: any) => ($setup.openDocument(doc))
                    }, [
                      ($setup.isImage(doc.fileName))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("img", {
                              src: doc.link,
                              alt: "Preview"
                            }, null, 8, _hoisted_9)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10)),
                      _createElementVNode("div", _hoisted_11, _toDisplayString($setup.getDocumentName(doc.fileName)), 1)
                    ], 8, _hoisted_7),
                    _createElementVNode("div", _hoisted_12, _toDisplayString($setup.formatDate(doc.modifiedDate)), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode($setup["DropDown"], { placement: 'right bottom' }, {
                        control: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("div", { class: "dots" }, [
                            _createElementVNode("div", { class: "actions" })
                          ], -1)
                        ]))]),
                        dropdown: _withCtx(() => [
                          _createElementVNode("ul", _hoisted_14, [
                            ($setup.lotId)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 0,
                                  onClick: ($event: any) => ($setup.showDeleteFileModal(doc.fileName, index))
                                }, [...(_cache[4] || (_cache[4] = [
                                  _createElementVNode("div", { class: "menu-item delete" }, "Delete File", -1)
                                ]))], 8, _hoisted_15))
                              : _createCommentVNode("", true),
                            _createElementVNode("li", {
                              onClick: ($event: any) => ($setup.downloadFile(doc.fileName, doc.link))
                            }, [...(_cache[5] || (_cache[5] = [
                              _createElementVNode("div", { class: "menu-item upload-file" }, "Download File", -1)
                            ]))], 8, _hoisted_16)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.docs, (item, index) => {
                  return (_openBlock(), _createBlock($setup["DocumentItem"], {
                    class: "block-documents--item",
                    key: index,
                    link: item.link,
                    name: item.fileName
                  }, null, 8, ["link", "name"]))
                }), 128))
              ])),
          (!$setup.docs?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                ($setup.props.tab === $setup.DocumentTypeEnum.CONTRACTS)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "You have not " + _toDisplayString($setup.isLotContractsTab ? "uploaded" : "signed") + " any " + _toDisplayString($props.tab) + " " + _toDisplayString($setup.isLotContractsTab ? "for" : "with") + " this " + _toDisplayString($setup.isLotContractsTab ? "lot" : "buyer") + " yet", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, "You have not uploaded any " + _toDisplayString($props.tab) + " for this lot yet", 1))
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_21)),
    _createVNode($setup["ImagePreviewModal"], {
      showImg: $setup.showImg,
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showImg = null))
    }, null, 8, ["showImg"]),
    _createVNode($setup["RemoveDocumentsModal"], {
      "is-open": $setup.isOpenRemoveDocumentsModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.isOpenRemoveDocumentsModal = false)),
      onConfirm: $setup.deleteDocument
    }, {
      title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
        _createElementVNode("span", { class: "description--highlighted" }, "Confirm action", -1)
      ]))]),
      description: _withCtx(() => [
        _cache[7] || (_cache[7] = _createTextVNode("Are you sure you want to delete file '", -1)),
        _createElementVNode("span", _hoisted_22, _toDisplayString($setup.getDocumentName($setup.fileForDelete.file)) + "' ?", 1)
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 2))
}